import { filter, fromEvent, map, tap } from 'rxjs';

import FullModal from 'utils/components/full-modal';

export default (node: HTMLElement, CLASSES: { HEADER_OVERLAY_ACTIVE: string }) => {
  const topLevelsLinks = node.querySelectorAll<HTMLElement>('[data-link-level="1"]');
  const container = node.querySelector('[data-target="mega-menu"]');

  const $click = fromEvent(topLevelsLinks, 'click').pipe(
    filter(
      (event) =>
        event.currentTarget instanceof HTMLElement &&
        event.currentTarget.dataset.child !== undefined,
    ),
    tap((event) => {
      event.preventDefault();
    }),
    map((event) => event.currentTarget as HTMLElement),
  );

  let currentActive: {
    link: HTMLElement;
    menu: FullModal;
  } = null;
  const menus = new Map(
    Array.from(container.querySelectorAll<HTMLElement>('[data-menu]')).map((menu) => [
      Array.from(topLevelsLinks).find((link) => link.dataset.child === menu.dataset.menu),
      new FullModal(menu, {
        overlay: {
          index: 20,
        },
      }),
    ]),
  );

  $click.subscribe((target) => {
    const menu = menus.get(target);

    if (currentActive) {
      currentActive.menu.close();
      currentActive.link.ariaExpanded = 'false';

      if (menu === currentActive.menu) {
        currentActive = null;

        return;
      }
    }

    if (menu) {
      menu.open();
      target.ariaExpanded = 'true';

      currentActive = {
        link: target,
        menu,
      };
    }
  });

  menus.forEach((menu) => {
    fromEvent(menu.root.querySelectorAll('[data-close]'), 'click').subscribe((event) => {
      event.preventDefault();

      menu.close();
    });

    menu.on('open', () => {
      node.setAttribute('data-overlay-element', 'navigation');
      node.classList.add(CLASSES.HEADER_OVERLAY_ACTIVE);
      document.body.style.overflow = 'hidden';
    });

    menu.on('close', () => {
      if (currentActive?.menu === menu) {
        currentActive.link.ariaExpanded = 'false';
        currentActive = null;
      }

      if (currentActive === null) {
        node.removeAttribute('data-overlay-element');
        node.classList.remove(CLASSES.HEADER_OVERLAY_ACTIVE);
        document.body.style.overflow = null;
      }
    });
  });
};
